import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { Modal, Input, H3, Text } from '@bigcommerce/big-design';

import { markPOClosed } from '../../redux/actions/purchaseOrders';

const ClosePOModal = ({ payload, showClosePOModal, setShowClosePOModal, purchaseOrder, closePo }) => {
  const update = () => {
    closePo(payload, purchaseOrder.id);
    setShowClosePOModal(false);
  }

  return(
    <>
      { purchaseOrder &&
        <Modal
          actions={[
            {
              text: 'Cancel',
              variant: 'subtle',
              onClick: () => setShowClosePOModal(false),
            },
            { text: 'Close PO', onClick: () => update() },
          ]}
          closeOnClickOutside={true}
          closeOnEscKey={true}
          header="Close PO"
          isOpen={showClosePOModal}
          onClose={() => setShowClosePOModal(false)}
        >
          <H3>{purchaseOrder.invoice_number || purchaseOrder.id}</H3>
          <Text>Confirm that this PO is complete and should be closed?</Text>
        </Modal>
      }
    </>
  )
}

const mapStateToProps = state => ({ 
});

const mapDispatchToProps = (dispatch) => ({
  closePo: (payload, purchaseOrderId) => dispatch(markPOClosed(payload, purchaseOrderId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ClosePOModal);